const ReviewConf = globalConf(globalReviewConf);

const Reviews = {
    customerId: +ReviewConf.customer.id,
    reviewSection: $('.product-reviews'),
    reviewSectionShort: $('.product-reviews.short-section'),
    submitForm: $('#product-reviews-form'),
    formStars: $('.form-group--stars > *'),
    formImages: $('input[name="images[0]"]'),
    accountProductIdArray: [],
    canWriteShortReview : false,

    errorMessage: "Відгук про товар можна залишити лише один раз після отримання товару по замовленню",
    successMessage: "Дякуємо за зворотній зв'язок з нами, ваш відгук успішно відправлено!",
    renderMessage: (el, message) => el.addClass('hidden').prevAll('.product-reviews-popup__title--main').addClass('hidden').prevAll('.product-reviews-popup__title--confirm').removeClass('hidden').text(message),

    allRatingsfromAllPages: [],
    renderReviewRating: (reviewRating) => {
        const htmlRatingElement = document.createElement('span');
        let htmlRating = $(htmlRatingElement);
        const htmlEmptyStarIcon =   `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                        <path d="M9 0L11.8566 5.06818L17.5595 6.21885L13.6221 10.5018L14.2901 16.2812L9 13.86L3.70993 16.2812L4.37787 10.5018L0.440492 6.21885L6.14336 5.06818L9 0Z" fill="#2B2D2F" fill-opacity="0.1"/>
                                    </svg>`;
        const htmlFullStarIcon =   `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                        <path d="M20 0L26.3481 11.2626L39.0211 13.8197L30.2714 23.3374L31.7557 36.1803L20 30.8L8.2443 36.1803L9.72859 23.3374L0.97887 13.8197L13.6519 11.2626L20 0Z" fill="#FF5500"/>
                                    </svg>`;
        switch (reviewRating) {
        case 1:
            htmlRating.html(htmlFullStarIcon + htmlEmptyStarIcon + htmlEmptyStarIcon + htmlEmptyStarIcon + htmlEmptyStarIcon);
            break;
        case 2:
            htmlRating.html(htmlFullStarIcon + htmlFullStarIcon + htmlEmptyStarIcon + htmlEmptyStarIcon + htmlEmptyStarIcon);
            break;
        case 3:
            htmlRating.html(htmlFullStarIcon + htmlFullStarIcon + htmlFullStarIcon + htmlEmptyStarIcon + htmlEmptyStarIcon);
            break;
        case 4:
            htmlRating.html(htmlFullStarIcon + htmlFullStarIcon + htmlFullStarIcon + htmlFullStarIcon + htmlEmptyStarIcon);
            break;
        case 5:
            htmlRating.html(htmlFullStarIcon + htmlFullStarIcon + htmlFullStarIcon + htmlFullStarIcon + htmlFullStarIcon);
            break;
        default:
            console.log('Product rating is 0');
        }
        return htmlRating[0];
    },
    renderReviewDate: (el) => {
        const date = new Date(el);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    },
    addTextForEmptyReviews: () => $('.product-reviews-all-tabs--wrapper .product-reviews-tabs--item').html(`<div class="h4 product-reviews--empty">Відгуки про товар відсутні.<br><br><span class="orange">Зроби замовлення на сайті та залиш відгук після того як ти отримаєш замовлення.</span></div>`),
    reviewValidation: (form) => {
        const self = Reviews;
        console.log('reviewValidation()');

        if(form.find('[name="type"]').val() == 4){
            // extended feedback form
            let isValid = true;

            const fields = form.find('textarea:not([name="questionnaire[1][answer]"])');

            fields.each((i, field)=>{
                const $field = $(field);
                const fieldVal = $field.val();

                let isFieldValid = self.validateTextReview(fieldVal, self.canWriteShortReview);

                if (!isFieldValid ) {
                    isValid = false;
                    $field.closest('.required').find('.product-reviews-form__item--error').removeClass('hidden');

                    $field.one('change input focus blur', function(event) {
                        $field.closest('.required').find('.product-reviews-form__item--error').addClass('hidden');
                        form.find('button[type="submit"]').removeClass('disabled').removeAttr('disabled');
                    });
                }

                // if ( $field.val().length === 0 || $field.val().length > 1000 ) {
                //     $field.closest('.required').find('.product-reviews-form__item--error').removeClass('hidden');
                //     isValid = false;
                // }
            });
            
            const field = form.find('textarea[name="questionnaire[1][answer]"]');
            if ( field.val().length > 1000 ) {
                field.closest('.required').find('.product-reviews-form__item--error').removeClass('hidden');
                isValid = false;
            }

            if(!isValid){
                form.find('button[type="submit"]').addClass('disabled');
                return false;
            } else {
                return true;
            }
        } else {
            // normal feedback form
            const commentField = form.find('textarea[name="comment"]');
            if (commentField) {
                let isValid = true;

                const commentFieldVal = commentField.val();
                console.log({commentFieldVal});

                isValid = self.validateTextReview(commentFieldVal, self.canWriteShortReview);

                console.log({isValid});

                if (isValid) {
                    return true;
                } else {
                    commentField.closest('.required').find('.product-reviews-form__item--error').removeClass('hidden');
                    form.find('button[type="submit"]').addClass('disabled');

                    commentField.one('change input focus blur', function(event) {
                        commentField.closest('.required').find('.product-reviews-form__item--error').addClass('hidden');
                        form.find('button[type="submit"]').removeClass('disabled').removeAttr('disabled');
                    });

                    return false;
                }
            }
        }
    },

    init: () => {
        console.log('reviews init');

        const self = Reviews;

        $(document).on('change', '.reviews-popup form textarea, .reviews-popup form input[name="images[0]"]', function () {
            var form = $(this).closest('form');
            $(this).closest('.required').find('.product-reviews-form__item--error').addClass('hidden');
            form.find('button[type="submit"]').removeClass('disabled').removeAttr('disabled');
        });

        self.formStars.on('click', function () {
            self.formStars.removeClass('filled');
            $(this).addClass('filled').prevAll().addClass('filled');
        });

        self.formImages.on('change', function () {
            if ($(this)[0].files.length > 0) {
                $(this).closest('.form-group--media').addClass('filled');
                $('.form-group--media input').closest('label').find('span').text($(this)[0].files[0].name);
            } else {
                $(this).closest('.form-group--media').removeClass('filled');
            }
        });

        self.submitForm.on('submit', function (evt) {
            evt.preventDefault();
            $(evt.currentTarget).find('[type="submit"]').prop('disabled', true).addClass('disabled');
            if ( self.reviewValidation(self.submitForm) ) {
                self.getCanWrite(self.submitForm, $(evt.currentTarget)[0]);
            }
        });

        if ( window.location.href.indexOf('account') < 0 ) {
            // reviews on PDP page
            console.log('reviews 1');
            self.productId = +$(self.submitForm).find('#product_id').val();
            self.getProductRating();
            self.getCanReviewProductInOrders(self.submitForm);
        }

        if( window.location.href.indexOf('account') !== -1){
            // reviews on account page
            console.log('reviews 2');
            self.accountPopup = $('.product-reviews-account-popup');
            self.accountProductBtns = self.accountPopup.find('.js-open-popup');

            self.getCanReviewOrders();
        }
    },

    getCanReviewOrders: () => {
        // reviews on account page
        const self = Reviews;
        const orders = document.getElementById('ordersProductReviewAcc');

        if(orders){

            const newOrders = JSON.parse(orders.innerHTML);

            if(newOrders.orders.length > 0){

                const data = {
                    'customer_id': self.customerId,
                    'orders': newOrders.orders
                }

                const isFirstReview = (orders, productId) => {
                    console.log('isFirstReview()', productId);
                    for (const order of orders) {
                        for (const product of order.products) {
                            if (product.id === productId) {
                                return product.is_first_review;
                            }
                        }
                    }
                    return false; // Product not found in any order
                };

                authToken.getReviewToken()
                .then((token) => {
                    $.ajax({
                        type: 'POST',
                        url: ReviewConf.domain + ReviewConf.methods.feedbacksCanWriteOrders + `?shop=${ReviewConf.shop_name}`,
                        dataType: "json",
                        data: JSON.stringify(data),
                        headers: ReviewConf.headers,
                        beforeSend: function (xhr) {
                            xhr.setRequestHeader('Authorization', sessionStorage.getItem('reviews_auth'));
                        },
                        success: (response) => {
                            const showReviewPopupBtns = document.querySelectorAll('.js-review-button');
                            showReviewPopupBtns.forEach(function(btn) {
                                const productId = +btn.dataset.product;

                                if (productId) {
                                    const isFirstReviewForProduct = isFirstReview(response.orders, productId);

                                    const canWriteShortReviewForProduct = !isFirstReviewForProduct;
                                    btn.dataset.shortReview = !isFirstReviewForProduct;

                                    btn.addEventListener('click', (e) => {
                                        self.canWriteShortReview = canWriteShortReviewForProduct;

                                        self.submitForm.removeClass('hidden');
                                        self.submitForm.prevAll('.product-reviews-popup__title--main').removeClass('hidden').prevAll('.product-reviews-popup__title--confirm').addClass('hidden');

                                        if (self.canWriteShortReview) {
                                            self.submitForm[0].dataset.novels = false;
                                            self.submitForm.find('[name="type"]').val(1);
                                            self.submitForm.find('.product-reviews-form-additional-items').addClass('hidden');
                                        }
                                    });
                                }
                            });

                            if ( self.accountPopup && response.orders ) {
                                let countRejOrder = 0;

                                $(response.orders).each((index, order) => {
                                    const orderPopup = $(`.product-reviews-account-popup[data-order-id="${order.id}"]`);
                                    if ( order.can_write_review ){
                                        $(order.products).each((index, product) => {
                                            if(!product.can_write_review){
                                                orderPopup.find(`.btn.btn-orange[data-product="${product.id}"]`).closest('.button-wrapper').remove();
                                            } else {
                                                if(product.canWriteNovelty !== undefined){
                                                    if(orderPopup.find(`.btn.btn-orange[data-product="${product.id}"]`).length > 1){
                                                        $.each(orderPopup.find(`.btn.btn-orange[data-product="${product.id}"]`), (i, val)=>{
                                                            $(val)[0].dataset.novels = product.canWriteNovelty;
                                                        });
                                                    } else {
                                                        const btn = orderPopup.find(`.btn.btn-orange[data-product="${product.id}"]`);
                                                        if(btn.length > 0){
                                                            btn[0].dataset.novels = product.canWriteNovelty;
                                                        }
                                                    }
                                                }
                                            }
                                        });
                                    } else {
                                        const orderWrapper = $(`.acc-main .acc-history-item[data-order-id="${order.id}"]`);

                                        orderWrapper.find(`.btn.btn-orange[data-order-id="${order.id}"]`).remove();
                                        orderWrapper.find('.acc-history-dropdown-review').remove();
                                        orderWrapper.removeClass('active');
                                        orderWrapper.find('.acc-history-dropdown').hide();

                                        countRejOrder++;
                                    }

                                });

                                if(response.orders.length === countRejOrder){
                                    const bannerReview = document.querySelector('.club-scoring-col.client-review');
                                    if(bannerReview){
                                        bannerReview.remove();
                                    }
                                }

                                setTimeout(() => {
                                    $('.acc-main .js-acc-history').removeClass('acc-loading');
                                    $('.acc-main #club-tab-main').removeClass('acc-loading');
                                }, 200);
                            }

                        },
                        error: (e) => {
                            console.log(e, 'error can`t write review');

                            const bannerReview = document.querySelector('.club-scoring-col.client-review');

                            if(bannerReview){
                                bannerReview.remove();
                            }

                            const orders = $('.acc-history-box').find('.acc-history-item ');

                            if(orders.length > 0){
                                orders.each((i, order) => {
                                    $(order).removeClass('active');
                                    $(order).find('.js-open-account-popup').remove();
                                    $(order).find('.acc-history-dropdown').hide();
                                    $(order).find('.acc-history-dropdown-review').remove();
                                });
                            }

                            setTimeout(() => {
                                $('.acc-main .js-acc-history').removeClass('acc-loading');
                                $('.acc-main #club-tab-main').removeClass('acc-loading');
                            }, 200);
                        }
                    });
                });
            } else {
                const bannerReview = document.querySelector('.club-scoring-col.client-review');

                if(bannerReview){
                    bannerReview.remove();
                }

                const orders = $('.acc-history-box').find('.acc-history-item ');

                if(orders.length > 0){
                    orders.each((i, order) => {
                        $(order).removeClass('active');
                        $(order).find('.js-open-account-popup').remove();
                        $(order).find('.acc-history-dropdown').hide();
                        $(order).find('.acc-history-dropdown-review').remove();
                    });
                }

                setTimeout(() => {
                    $('.acc-main .js-acc-history').removeClass('acc-loading');
                    $('.acc-main #club-tab-main').removeClass('acc-loading');
                }, 200);
            }

        }

    },

    getCanReviewProductInOrders: () => {
        // reviews on PDP page

        const self = Reviews;

        const orders = document.getElementById('ordersProductReview');

        if(orders){

            const newOrders = JSON.parse(orders.innerHTML);

            if(newOrders.orders.length > 0){

                const data = {
                    'customer_id': self.customerId,
                    'orders': newOrders.orders
                }

                const isFirstReview = (orders, productId) => {
                    for (const order of orders) {
                        for (const product of order.products) {
                            if (product.id === productId) {
                                return product.is_first_review;
                            }
                        }
                    }
                    return false;
                };

                authToken.getReviewToken()
                .then((token) => {
                    $.ajax({
                        type: 'POST',
                        url: ReviewConf.domain + ReviewConf.methods.feedbacksCanWriteOrders + `?shop=${ReviewConf.shop_name}`,
                        dataType: "json",
                        data: JSON.stringify(data),
                        headers: ReviewConf.headers,
                        beforeSend: function (xhr) {
                            xhr.setRequestHeader('Authorization', sessionStorage.getItem('reviews_auth'));
                        },
                        success: (response) => {
                            var showMessage = true,
                                productId = +self.submitForm.find('[name="product_id"]').val();

                            const isFirstReviewForProduct = isFirstReview(response.orders, productId);

                            if (!isFirstReviewForProduct) {
                                console.log('allow short review');
                                self.canWriteShortReview = true;
                                console.log('self.canWriteShortReview', self.canWriteShortReview);
                            } else {
                                console.log('disallow short review');
                            }

                            console.log({isFirstReviewForProduct});

                            // if (response.orders && self.canWriteShortReview != false) {
                            if (response.orders) {
                                $(response.orders).each((index, order) => {
                                    if ( order.can_write_review ){
                                        $(order.products).each((index, product) => {
                                            if(+product.id === productId && product.can_write_review){
                                                self.submitForm.find('[name="order_id"]').val(order.id);
                                                if(product.canWriteNovelty && self.canWriteShortReview == false) {
                                                    self.submitForm[0].dataset.novels = product.canWriteNovelty;
                                                    self.submitForm.find('[name="type"]').val(4);
                                                    self.submitForm.find('.product-reviews-form-additional-items').removeClass('hidden');
                                                }
                                                showMessage = false;
                                            }
                                        });
                                    }
                                });
                            }

                            if (showMessage) {
                                self.renderMessage(self.submitForm, self.errorMessage);
                            }

                        },
                        error: (e) => {
                            console.log(e, 'error can`t write review');
                            self.renderMessage(self.submitForm, self.errorMessage);
                        }
                    });
                });
            } else {
                self.renderMessage(self.submitForm, self.errorMessage);
            }

        } else {
            self.renderMessage(self.submitForm, self.errorMessage);
        }
    },

    validateTextReview: (reviewText, isShort) => {
        console.log('validateTextReview');
        console.log({reviewText});
        console.log({isShort});

        let isValid = true;

        if (isShort) {
          console.log('review requirments type: short');
          if (reviewText.length < 10) {
            console.log('повідомлення менше 10 символів');
            isValid = false;
          }
        } else {
          console.log('review requirments type: long');
          if (reviewText.length < 50) {
            console.log('повідомлення менше 50 символів');
            isValid = false;
          }

          const words = reviewText.split(/\s+/);

          if (words.length < 4) {
              console.log('повідомлення містить мало слів');
              isValid = false;
          }

          const uniqueWords = new Set(words);
          if (uniqueWords.size < words.length / 2) {
            console.log('повідомлення містить багато повторень слів');
            isValid = false;
          }

          for (let i = 0; i < words.length - 2; i++) {
              if (words[i] === words[i + 1] && words[i + 1] === words[i + 2]) {
                  console.log('повідомлення містить три одинакові слова підряд');
                  isValid = false;
                  break;
              }
          }

          const letterRegex = /[а-яА-Яa-zA-Z]/g;
          const letters = reviewText.match(letterRegex);

          if (!letters) {
            console.log('повідомлення не містить літер');
            // return false;
            isValid = false;
          }

          if (letters) {
              const letterPercentage = letters.length / reviewText.length;
              if (letterPercentage < 0.5) {
                console.log('повідомлення містить мало літер');
                // return false;
                isValid = false;
              }
          }
        }

        return isValid;
    },


    getCanWrite: (form = false, formData = false, productId = false) => {
        console.log('getCanWrite()');
        const self = Reviews;
        let product_id;
        if (productId) {
            product_id = productId;
        } else {
            product_id = +form.find('#product_id').val();
        }

        let order_id;

        if(form){
            order_id = form.find('#order_id').val();
        }



        const data = {
            'customer_id': self.customerId,
            'order_id': order_id,
            'product_id': product_id
        }

        authToken.getReviewToken()
        .then((token) => {
            $.ajax({
                type: 'POST',
                url: ReviewConf.domain + ReviewConf.methods.feedbacksCanWrite + `?shop=${ReviewConf.shop_name}`,
                dataType: "json",
                data: JSON.stringify(data),
                headers: ReviewConf.headers,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', sessionStorage.getItem('reviews_auth'));
                },
                success: (response) => {
                    if ( formData ) self.feedbacksStore(formData, product_id);
                },
                error: (e) => {
                    self.renderMessage(self.submitForm, self.errorMessage);
                    if ( self.accountPopup ) {
                        self.accountPopup.removeClass('active');

                        self.accountProductBtns.each(function () {
                            const accountProductId = $(this).data('product');
                            if ( accountProductId === product_id ) {
                                $(this).parent().remove();
                            }
                        })

                        self.accountPopup.each(function () {
                            if ( $(this).find('.button-wrapper').length === 0 ) {
                                const orderId = $(this).closest('[data-order-id]').data('order-id');
                                $('.acc-main').find(`.btn.btn-orange[data-order-id="${orderId}"]`).remove();

                                $('.acc-history-dropdown-review').each(function (i) {
                                    let dropdownReview = $(this);
                                    let dropdownReviewItem = $(this).closest('.acc-history-item');

                                    $(dropdownReviewItem).removeClass('active');
                                    dropdownReviewItem.find('.acc-history-dropdown').hide();
                                    if ( dropdownReviewItem.find(`.btn.btn-orange[data-order-id="${orderId}"]`).length === 0 ) {
                                        dropdownReview.hide();
                                    }
                                });
                            }
                        })
                        setTimeout(() => {
                            $('.acc-preloader').hide();
                            $('.acc-main .acc-history-box').removeClass('hidden');
                            $('.acc-main .acc-club-content').removeClass('hidden');
                        }, 200);
                    }
                }
            });
        });
    },

    feedbacksStore: (form, id) => {
        const self = Reviews;
        let data = new FormData(form);

        authToken.getReviewToken()
        .then((token) => {
            $.ajax({
                type: 'POST',
                url: ReviewConf.domain + ReviewConf.methods.feedbacksStore + `?shop=${ReviewConf.shop_name}`,
                crossDomain: true,
                dataType: "json",
                contentType: "multipart/form-data",
                processData: false,
                contentType: false,
                data: data,
                headers: {
                    "Accept": "application/json",
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', sessionStorage.getItem('reviews_auth'));
                },
                success: (response) => {
                    self.renderMessage(self.submitForm, self.successMessage);
                    if ( self.accountPopup ) {
                        $('.acc-main').find(`.btn.btn-orange[data-product="${id}"]`).parent().remove();
                        self.accountPopup.removeClass('active');

                        let btns = self.accountPopup.find(`.btn.btn-orange[data-product="${id}"]`);
                        if(btns.length > 0){
                            btns.each((index,btn)=>{
                                $(btn).parent().remove();
                            });
                        }

                        self.accountPopup.each(function (i, item) {
                            let accountBtns = $(item).find(`.js-review-button`).parent('.button-wrapper');
                            if (accountBtns.length === 0) {
                                $(`.js-open-account-popup[data-order-id="${$(item).data('order-id')}"]`).parent().remove();
                            }
                        })
                    }
                },
                error: (e) => {
                    console.log(e);
                    if ( e.responseText.indexOf('must be a file of type') > -1 ) {
                        self.formImages.closest('.required').find('.product-reviews-form__item--error').removeClass('hidden');
                        form.find('button[type="submit"]').addClass('disabled');
                    }
                }
            });
        });
    },

    getProductRating: () => {
        const self = Reviews;

        authToken.getReviewToken().then((token) => {
                const formattedMethod = ReviewConf.methods.productRating.replace('@id', self.productId);

                $.ajax({
                    url: ReviewConf.domain +'/'+ formattedMethod + `?shop=${ReviewConf.shop_name}`,
                    method: "GET",
                    dataType: "json",
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader('Authorization', token);
                    },
                    success: function (res) {

                        if ( res.success === false ) {
                            $('.product-reviews-count--all').text('0');
                            self.addTextForEmptyReviews();

                        } else {
                            const rating = res.data.rating;
                            const ratingFields = $('.product-reviews-info--stars');
                            let ratingField;
                            const ratingCountField = $('.product-reviews-info--rating');
                            const fullStarIcon =   `<path d="M20 0L26.3481 11.2626L39.0211 13.8197L30.2714 23.3374L31.7557 36.1803L20 30.8L8.2443 36.1803L9.72859 23.3374L0.97887 13.8197L13.6519 11.2626L20 0Z" fill="#FF5500"/>`;

                            ratingFields.each(function (i) {
                                ratingField = $(this);

                                if ( rating >= 4.5 ) {
                                    ratingField.find('>svg').html(fullStarIcon);
                                } else if ( rating >= 3.5 ) {
                                    ratingField.find('>svg:not(:last-child)').html(fullStarIcon);
                                    ratingField.find('>svg:nth-child(4)').html(fullStarIcon);
                                } else if ( rating >= 2.5 ) {
                                    ratingField.find('>svg:first-child, >svg:nth-child(2), >svg:nth-child(3)').html(fullStarIcon);
                                } else if ( rating >= 1.5 ) {
                                    ratingField.find('>svg:first-child, >svg:nth-child(2)').html(fullStarIcon);
                                } else if ( rating >= 0.5 ) {
                                    ratingField.find('>svg:first-child').html(fullStarIcon);
                                }
                            });
                            
                            ratingCountField.text(rating);
                            if ( ratingCountField.text().indexOf('.') === -1 ) {
                                ratingCountField.append('.0');
                            }

                            self.GetProductPaginationList(false, res.data.rating);
                        }
                    },
                    error: (err) => {
                        return false;
                    }
                })
            }
        )
    },

    GetProductPaginationList: (page = false, productRating = false) => {
        const self = Reviews;
        self.review = $('.product-reviews-all-tabs--wrapper .product-reviews-tabs--item');

        authToken.getReviewToken().then((token) => {
                const formattedMethod = ReviewConf.methods.productReviews.replace('@id', self.productId);
                const params = () => page ? `?page=${page}&shop=${ReviewConf.shop_name}` : `?shop=${ReviewConf.shop_name}`;

                $.ajax({
                    url: ReviewConf.domain + formattedMethod + params(),
                    method: "GET",
                    dataType: "json",
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader('Authorization', token);
                    },
                    success: function (res) {
                        const allReviewsCount = res.meta.total;
                        const allReviews = res.data;
                        let reviewItem = self.review;
                        const showMoreReviewsBtn = `<div data-url-next-page="${res.meta.current_page + 1}" class="button-wrapper button-wrapper-black js-show-more-reviews">
                                                        <div class="btn btn-black"><span class="btn__text">Показати більше</span></div>
                                                    </div>`;
                        let showMoreReviewsUrl = '';
                        const isShortSection = self.reviewSectionShort.length;
                        let paginationNumber = allReviews.length;
                        
                        $('.product-reviews-count--all').text(allReviewsCount);

                        if ( allReviewsCount > 0 ) {
                            reviewItem.closest('.product-reviews-tabs--wrapper').addClass('product-reviews-tabs--reverse');
                        } else {
                            self.addTextForEmptyReviews();
                            self.reviewSection.find('[data-reviews-tab-link]').addClass('hidden');
                        }

                        if(isShortSection){
                            showMoreReviewsUrl = `<a href="${self.reviewSectionShort.data('url')}" class="button-wrapper button-wrapper-black">
                                                        <div class="btn btn-orange"><span class="btn__text">Показати більше</span></div>
                                                    </a>`;
                            if(paginationNumber > 3) paginationNumber = 3;
                        }

                        for (let item = 0; item < paginationNumber; item++) {
                            
                            if ( self.reviewSection.find('.not-authorized-block').length > 0 && item > 0 ) break;

                            let review = allReviews[item];

                            console.log(review);
                            let questionnaireHtml = `${review.comment}`;

                            if(review.questionnaire !== null){
                                questionnaireHtml = `${review.comment}<br> <b>Що сподобалося:</b> ${review.questionnaire[0].answer}`;
                            }

                            const htmlReview = `<div class="product-reviews-tabs--item__block flex --direction-col">
                                                    <div class="product-reviews-tabs--item__top">
                                                        <div class="product-reviews-tabs--item__info flex --align-center --justify-between">
                                                        <div class="product-reviews-tabs--item__name">${review.customer.public_name}</div>
                                                            <div class="product-reviews-tabs--item__rating flex --align-center">
                                                                <span class="product-reviews-tabs--item__date">${self.renderReviewDate(review.created_at)}</span>
                                                                <span class="product-reviews-tabs--item__stars"></span>
                                                            </div>
                                                        </div>
                                                        <div class="product-reviews-tabs--item__status flex --align-center">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                                            <path d="M2.5 11.875C2.5 12.2065 2.6317 12.5245 2.86612 12.7589C3.10054 12.9933 3.41848 13.125 3.75 13.125C4.08152 13.125 4.39946 12.9933 4.63388 12.7589C4.8683 12.5245 5 12.2065 5 11.875C5 11.5435 4.8683 11.2255 4.63388 10.9911C4.39946 10.7567 4.08152 10.625 3.75 10.625C3.41848 10.625 3.10054 10.7567 2.86612 10.9911C2.6317 11.2255 2.5 11.5435 2.5 11.875Z" stroke="#009421" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <path d="M7.1875 10.625H3.75V1.875H2.5" stroke="#009421" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <path d="M3.75 3.125L12.5 3.75L11.875 8.125H3.75M9.375 11.875L10.625 13.125L13.125 10.625" stroke="#009421" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                            <span>Замовлення отримано</span>
                                                        </div>
                                                    </div>
                                                    <div class="product-reviews-tabs--item__text">
                                                     ${questionnaireHtml}
                                                    </div>
                                                    <div class="product-reviews-tabs--item__media"></div>
                                                </div>`;

                            reviewItem.append(htmlReview);
                            reviewItem.find('.product-reviews-tabs--item__block:last-child').find('.product-reviews-tabs--item__stars').html(self.renderReviewRating(review.rating));

                            if ( review.images.length > 0 ) {
                                for ( let image in review.images ) {
                                    let htmlImage = document.createElement('img');
                                    htmlImage.src = review.images[image].path;
                                    const feedbackImageField = $('.product-reviews-all-tabs--wrapper .product-reviews-tabs--item__block:last-child');
                                    $(feedbackImageField).find('.product-reviews-tabs--item__media').html(htmlImage);
                                }
                            }

                            if ( review.answer ) {
                                const htmlReviewAnswer = `<div class="product-reviews-tabs--item__reply">
                                        <div class="product-reviews-tabs--item__info flex --align-center --justify-between">
                                            <div class="product-reviews-tabs--item__name">
                                                <svg width="119" height="47" viewBox="0 0 119 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M16.6408 3.20155e-07C13.3501 -0.000641987 10.133 0.965197 7.39659 2.77537C4.66014 4.58555 2.52716 7.15874 1.2674 10.1695C0.00764725 13.1803 -0.322299 16.4935 0.319293 19.69C0.960884 22.8866 2.54519 25.8229 4.87186 28.1276C7.19852 30.4323 10.163 32.002 13.3905 32.638C16.6179 33.2741 19.9634 32.948 23.0036 31.7009C26.0439 30.4539 28.6426 28.3419 30.4709 25.6322C32.2992 22.9224 33.275 19.7365 33.275 16.4774C33.275 12.1079 31.5226 7.9173 28.4032 4.82728C25.2837 1.73725 21.0528 0.00086148 16.6408 3.20155e-07ZM16.6408 26.0541C14.7274 26.0547 12.8568 25.4934 11.2655 24.4409C9.67433 23.3885 8.43401 21.8924 7.70148 20.1418C6.96895 18.3911 6.77712 16.4647 7.15025 14.606C7.52338 12.7474 8.4447 11.0401 9.79769 9.70018C11.1507 8.36021 12.8745 7.44774 14.7512 7.0782C16.6279 6.70866 18.5731 6.89865 20.3407 7.62414C22.1083 8.34962 23.619 9.578 24.6817 11.1539C25.7443 12.7298 26.3111 14.5824 26.3105 16.4774C26.307 19.0163 25.2871 21.4501 23.4745 23.2454C21.6618 25.0406 19.2043 26.0507 16.6408 26.0541Z" fill="#FF5500"/>
                                                        <path d="M101.941 3.20155e-07C98.6499 -0.000641987 95.4329 0.965197 92.6964 2.77537C89.9599 4.58555 87.827 7.15874 86.5672 10.1695C85.3075 13.1803 84.9775 16.4935 85.6191 19.69C86.2607 22.8866 87.845 25.8229 90.1717 28.1276C92.4983 30.4323 95.4628 32.002 98.6903 32.638C101.918 33.2741 105.263 32.948 108.303 31.7009C111.344 30.4539 113.942 28.3419 115.771 25.6322C117.599 22.9224 118.575 19.7365 118.575 16.4774C118.575 12.1079 116.822 7.9173 113.703 4.82728C110.584 1.73725 106.353 0.00086148 101.941 3.20155e-07ZM101.941 26.0541C100.027 26.0547 98.1566 25.4934 96.5653 24.4409C94.9741 23.3885 93.7338 21.8924 93.0013 20.1418C92.2688 18.3911 92.0769 16.4647 92.4501 14.606C92.8232 12.7474 93.7445 11.0401 95.0975 9.70018C96.4505 8.36021 98.1743 7.44774 100.051 7.0782C101.928 6.70866 103.873 6.89865 105.641 7.62414C107.408 8.34962 108.919 9.578 109.981 11.1539C111.044 12.7298 111.611 14.5824 111.61 16.4774C111.607 19.0163 110.587 21.4501 108.774 23.2454C106.962 25.0406 104.504 26.0507 101.941 26.0541Z" fill="#FF5500"/>
                                                        <path d="M64.9639 5.73517e-06C62.3427 -0.00215997 59.7581 0.609062 57.4207 1.78386C55.0833 2.95866 53.0593 4.66379 51.5135 6.76029C49.9677 8.8568 48.944 11.2854 48.5257 13.848C48.1074 16.4107 48.3064 19.035 49.1065 21.5071C49.9066 23.9792 51.2852 26.229 53.1298 28.0733C54.9744 29.9176 57.233 31.3042 59.7213 32.12C62.2097 32.9359 64.8575 33.1579 67.4489 32.768C70.0404 32.378 72.5021 31.3873 74.6336 29.8763V30.5258C74.631 33.0649 73.6114 35.4993 71.7985 37.2947C69.9857 39.0901 67.5276 40.0999 64.9639 40.1025V47C69.3759 47 73.6072 45.2644 76.7272 42.175C79.8473 39.0856 81.6005 34.8953 81.6014 30.5258C81.6014 22.8197 81.6014 16.458 81.6014 16.458C81.5962 12.0912 79.841 7.90515 76.7214 4.81924C73.6019 1.73334 69.373 2.68217e-06 64.9639 5.73517e-06ZM64.9639 26.0541C63.0505 26.0547 61.1799 25.4934 59.5886 24.441C57.9974 23.3885 56.7571 21.8924 56.0246 20.1418C55.292 18.3911 55.1002 16.4647 55.4733 14.606C55.8465 12.7474 56.7678 11.0402 58.1208 9.70018C59.4738 8.36021 61.1976 7.44775 63.0743 7.07821C64.951 6.70867 66.8962 6.89866 68.6638 7.62414C70.4314 8.34962 71.9421 9.57801 73.0047 11.1539C74.0674 12.7298 74.6342 14.5824 74.6336 16.4774V16.5262C74.6336 16.5262 74.6336 16.5521 74.6336 16.5651C74.6068 19.0887 73.5767 21.5002 71.7665 23.2765C69.9564 25.0528 67.5121 26.0508 64.9639 26.0541Z" fill="#FF5500"/>
                                                        <path d="M40.7288 0.0979004L36.3416 9.58688H44.0635L48.4508 0.0979004H40.7288Z" fill="#FF5500"/>
                                                    </svg>                              
                                                    Представник бренду
                                                </div>
                                            <div class="product-reviews-tabs--item__date">${self.renderReviewDate(review.answer.created_at)}</div>
                                        </div>
                                        <div class="product-reviews-tabs--item__text">${review.answer.comment}</div>
                                    </div>`;
                                const feedbackAnswerField = $('.product-reviews-all-tabs--wrapper .product-reviews-tabs--item__block:last-child');
                                $(feedbackAnswerField).append(htmlReviewAnswer);
                            }

                            // if ( review.rating > bestRating ) bestRating = review.rating;
                            // if ( review.rating < worstRating ) worstRating = review.rating;
                            //
                            // if ( allReviewsCount > 0  && review.rating !== null) {
                            //     const allRating = {
                            //         "@type": "Review",
                            //         "reviewRating": {
                            //             "@type": "Rating",
                            //             "ratingValue": review.rating.toString()
                            //         },
                            //         "author": {
                            //             "@type": "Person",
                            //             "name": `${review.customer.public_name}`
                            //         }
                            //     };
                            //
                            //     self.allRatingsfromAllPages.push(allRating)
                            // }
                        }

                        if(isShortSection &&  allReviews.length > 3){
                            $('.product-reviews-all-tabs--wrapper .product-reviews-tabs--btn').html(showMoreReviewsUrl);
                        } else {
                            if ( !(res.links.next === null) ) $('.product-reviews-all-tabs--wrapper .product-reviews-tabs--btn').html(showMoreReviewsBtn);
                        }

                        $('.js-show-more-reviews').on('click', function (e) {
                            $(e.currentTarget).remove();
                            self.GetProductPaginationList($(this).data('url-next-page'), productRating);
                        });

                        // schema.org changes
      
                        // let jsonldField = $('.template-product').find('script[type="application/ld+json"]:last-child');
                        // let jsonld = JSON.parse(jsonldField.text());
                        //
                        // if ( allReviewsCount > 0 ) {
                        //
                        //     const aggregateRating = {
                        //         "@type": "AggregateRating",
                        //         "ratingValue": productRating.toString(),
                        //         "ratingCount": allReviewsCount.toString(),
                        //         "bestRating": bestRating.toString(),
                        //         "worstRating": worstRating.toString()
                        //     };
                        //
                        //     jsonld.aggregateRating = aggregateRating;
                        //     jsonld.review = self.allRatingsfromAllPages;
                        // }
                        //
                        // jsonldField.text(JSON.stringify(jsonld))
                    },
                    error: (err) => {
                        return false;
                    }
                })
            }
        )
    }
}

$(document).ready(function () {
    Reviews.init();
})